import moveToMenuStore from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Sets the valid/invalid state for the new category
 * @param text the new category name
 */
export default mutatorAction('setNewFolderInvalidState', function setNewFolderInvalidState(isInvalid) {
    moveToMenuStore.newFolderViewState.isInvalid = isInvalid;
});
//# sourceMappingURL=setNewFolderInvalidState.js.map